export var escapeUri = function (uri) {
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function (c) { return "%" + c.charCodeAt(0).toString(16).toUpperCase(); };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/util-uri-escape/dist-es/escape-uri.js
// module id = 350
// module chunks = 0